import { onMounted, onUnmounted } from 'vue';

const EXIT_INTENT_SESSION_KEY = 'coolliving_exit_intent_shown';

/**
 * Exit-intent para marketplace (desktop): mouse sale por arriba del viewport.
 */
export function useExitIntent({ canShow, onTrigger }) {
  function handleMouseLeave(event) {
    if (event.clientY > 0) return;
    if (sessionStorage.getItem(EXIT_INTENT_SESSION_KEY)) return;
    if (typeof canShow === 'function' && !canShow()) return;

    sessionStorage.setItem(EXIT_INTENT_SESSION_KEY, '1');
    onTrigger?.();
  }

  onMounted(() => {
    document.documentElement.addEventListener('mouseleave', handleMouseLeave);
  });

  onUnmounted(() => {
    document.documentElement.removeEventListener('mouseleave', handleMouseLeave);
  });
}
